<div class="modal-header" id="duration-manual-input-modal-title">
    <h3 class="modal-title" translate="DURATION_MANUAL_INPUT_TITLE"></h3>
    <button
        class="close"
        type="button"
        [attr.aria-label]="'DURATION_STEPPER_CANCEL' | translate"
        (click)="modalInstance.hide()"
    >
        &times;
    </button>
</div>
<div class="modal-body">
    <div class="row mb-3">
        <div class="col">
            <label for="duration-manual-hours" translate="DURATION_MANUAL_INPUT_HOURS"></label>
            <input
                #hoursInput
                class="form-control input-md duration-part"
                id="duration-manual-hours"
                type="number"
                inputmode="numeric"
                min="0"
                [value]="hours() ?? ''"
                [class.is-invalid]="isInvalid()"
                (input)="onHoursInput($event)"
                (keyup.enter)="save()"
            />
        </div>
        <div class="col">
            <label for="duration-manual-minutes" translate="DURATION_MANUAL_INPUT_MINUTES"></label>
            <input
                #minutesInput
                class="form-control input-md duration-part"
                id="duration-manual-minutes"
                type="number"
                inputmode="numeric"
                min="0"
                [max]="maxMinuteValue"
                [value]="minutes() ?? ''"
                [class.is-invalid]="isInvalid()"
                (input)="onMinutesInput($event)"
                (keyup.enter)="save()"
            />
        </div>
    </div>
    @for (message of errorMessages(); track message) {
        <div class="row mb-3">
            <small class="col error">{{ message }}</small>
        </div>
    }
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        type="button"
        translate="DURATION_STEPPER_CANCEL"
        (click)="modalInstance.hide()"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        translate="DURATION_STEPPER_DONE"
        [disabled]="isInvalid()"
        (click)="save()"
    ></button>
</div>
